import React from 'react';
import { Calendar } from 'lucide-react';

/**
 * Seletor de data para auditoria
 */
export default function SeletorData({ date, onDateChange }) {
  return (
    <div className="flex items-center gap-3 bg-white p-3 rounded-3xl shadow-xl border-2 border-green-100">
      <Calendar className="text-green-600 ml-2" size={24}/>
      <input 
        type="date" 
        className="bg-transparent font-black text-green-900 outline-none p-1"
        value={date}
        onChange={e => onDateChange(e.target.value)}
      />
    </div>
  );
}





